// Module
var code = `<svg class="cp-icon" ng-attr-width="{{ vm.size }}" ng-attr-height="{{ vm.size }}"> <use xlink:href="{{ '#icon-' + vm.name }}"></use> </svg> `;
// Exports
module.exports = code;